import JetButton from '@src/shared/components/JetButton';
import React, { CSSProperties, FC } from 'react';
import { EBottomSheetAction, TBottomSheetAction } from '../CourierBottomSheet';
import styles from './CourierDetailActionsButton.module.scss';
type TCourierDetailActionsProps = {
  onButtonAction: (action: TBottomSheetAction) => void;
  actionType: EBottomSheetAction;
  buttonText: string;
  isDisabled?: boolean;
  startIcon?: React.ReactNode;
  customStyle?: CSSProperties;
  containerCustomStyle?: CSSProperties;
  clearContainerSpaces?: boolean;
  isLoading?: boolean;
};

export const CourierDetailActionsButton: FC<TCourierDetailActionsProps> = ({
  onButtonAction,
  actionType,
  buttonText,
  isDisabled,
  startIcon,
  customStyle,
  containerCustomStyle,
  clearContainerSpaces = false,
  isLoading = false,
}) => {
  /* Hooks */

  /* Component Utils */
  const getButtonVariations = (actionType: EBottomSheetAction) => {
    switch (actionType) {
      case EBottomSheetAction.Send:
      case EBottomSheetAction.ReSend:
      case EBottomSheetAction.Confirm:
        return 'primary';
      case EBottomSheetAction.View:
        return 'ghostbutton';
      case EBottomSheetAction.Disconnect:
        return 'default';
      default:
        return 'ghostbutton';
    }
  };

  const getButtonSize = (actionType: EBottomSheetAction) => {
    switch (actionType) {
      case EBottomSheetAction.Send:
      case EBottomSheetAction.ReSend:
        return 'medium';
      case EBottomSheetAction.View:
      case EBottomSheetAction.Delete:
      case EBottomSheetAction.Disconnect:
      case EBottomSheetAction.Confirm:
        return 'small';
      default:
        return 'xsmall';
    }
  };

  return (
    <div
      style={{ ...containerCustomStyle }}
      className={`${styles.courierDetailActionsButtonContainer} ${
        clearContainerSpaces ? styles.clearContainerSpaces : ''
      }`}
    >
      {/* TODO:THIS SECTION WILL BE UPDATED WITH SNACK LIBRARY */}
      <JetButton
        onClick={() => onButtonAction({ type: actionType, source: { text: 'button' } })}
        variation={getButtonVariations(actionType)}
        size={getButtonSize(actionType)}
        disabled={isDisabled}
        isLoading={isLoading}
        startIcon={!isLoading ? startIcon : null}
        style={
          { ...customStyle } || {
            minHeight: '40px',
            height: 'auto',
            width: 'auto',
          }
        }
      >
        {buttonText}
      </JetButton>
    </div>
  );
};

export default CourierDetailActionsButton;
